module.exports = __webpack_public_path__ + "static/media/Chapter.f42d283a.svg";